import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Swal from "sweetalert2";
import axios from "axios";
import html2pdf from "html2pdf.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PlaceOrders = () => {
  const API_URL = "https://sunrise-backend.sunrisemeditechsystems.com/api";
  const [orderType, setOrderType] = useState("buy");
  const [quantity, setQuantity] = useState(1);
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [productType, setProductType] = useState("repair");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [doctorPhone, setDoctorPhone] = useState("");
  const [receiverName, setReceiverName] = useState("");
  const [receiverPhone, setReceiverPhone] = useState("");
  const [photo, setPhoto] = useState("");
  const [hospitalAddress, setHospitalAddress] = useState("");
  const [notes, setNotes] = useState("");
  const [productData, setProductData] = useState({});
  const [ProductDetail, setProductDetail] = useState([]);
  const [productId, setProductId] = useState(0);
  const [placeOrderData, setPlaceOrderData] = useState({});

  const initialValues = {
    orderType: "buy",
    quantity: 1,
    startDate: "",
    endDate: "",
    hospitalName: "",
    productType: "",
    doctorName: "",
    doctorPhone: "",
    receiverName: "",
    receiverPhone: "",
    notes: "",
    hospitalAddress: "",
    photo: null,
  };
  const calculateTotal = () => {
    if (!product) return 0;
    if (orderType === "buy") {
      return product.salePrice * quantity;
    } else {
      if (!startDate || !endDate) return 0;
      const start = new Date(startDate);
      const end = new Date(endDate);
      const days = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
      return product.rentalPrice * days * quantity;
    }
  };

  const downloadChallan = () => {
    if (!hospitalName || !doctorName || !doctorPhone || !hospitalAddress) {
      Swal.fire("Error", "Please fill all required fields", "error");
      return;
    }
    if (
      orderType === "stand_by" &&
      (!startDate ||
        !endDate ||
        !productType ||
        !receiverName ||
        !receiverPhone ||
        !notes)
    ) {
      Swal.fire("Error", "Please fill all standby product details", "error");
      return;
    }

    const challan = document.getElementById("standby-challan");
    const opt = {
      margin: 10,
      filename: `standby_challan_${hospitalName.replace(/\s+/g, "_")}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };
    html2pdf().from(challan).set(opt).save();
  };
  const handleFileChange = (e) => {
    const value = e.target.files && e.target.files[0];
    setPhoto(value);
  };
  const handleOrderSubmit = async (e) => {
    // Validation
    if (!hospitalName || !doctorName || !doctorPhone || !hospitalAddress) {
      Swal.fire("Error", "Please fill all required fields", "error");
      return;
    }

    if (
      orderType === "stand_by" &&
      (!startDate ||
        !endDate ||
        !productType ||
        !receiverName ||
        !receiverPhone ||
        !notes)
    ) {
      Swal.fire("Error", "Please fill all standby product details", "error");
      return;
    }

    if (
      (orderType === "stand_by" || orderType === "demo") &&
      (!startDate || !endDate)
    ) {
      Swal.fire("Error", "Please select demo product duration", "error");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        Swal.fire("Error", "Please login to place order", "error");
        navigate("/login");
        return;
      }

      // ✅ Create FormData
      const formData = new FormData();
      formData.append("product_id", productId);

      // Add photo only if applicable
      if (orderType === "stand_by" && photo) {
        formData.append("photo", photo); // File from <input type="file">
      }

      // Append normal fields
      formData.append("source", "sunrise-webapp");
      formData.append(
        "product_type",
        orderType === "stand_by" ? productType : ""
      );
      formData.append("confirmed", false);
      const items = [
        {
          product: productData.id,
          name: productData.name,
          image: productData.image,
          price:
            orderType === "buy"
              ? productData.salePrice
              : productData.rentalPrice,
          quantity,
          buyOrRent: orderType,
          startDate:
            orderType === "stand_by" || orderType === "demo"
              ? startDate
              : undefined,
          endDate:
            orderType === "stand_by" || orderType === "demo"
              ? endDate
              : undefined,
        },
      ];
      formData.append("items", JSON.stringify(items));

      const shippingAddress = {
        hospitalName,
        doctorName,
        doctorPhone,
        hospitalAddress,
        receiverName,
        receiverPhone,
      };
      formData.append("shippingAddress", JSON.stringify(shippingAddress));

      // ✅ Send request
      await axios.post(`${API_URL}/orders/create`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Order placed successfully!", {
        position: "top-right",
        autoClose: 3000, // Toast will disappear after 3 seconds
      });

      navigate("/orders");

      // Reset form
      setHospitalName("");
      setDoctorName("");
      setDoctorPhone("");
      setReceiverName("");
      setReceiverPhone("");
      setHospitalAddress("");
      setNotes("");
      setPhoto(null);
      setStartDate("");
      setEndDate("");
    } catch (error) {
       toast.error(error, {
        position: "top-right",
        autoClose: 3000, // Toast will disappear after 3 seconds
      });
    }
  };
  useEffect(() => {
    fetchProducts();
    fetchProductDetails();
  }, []);

  useEffect(() => {
    fetchPlaceOrder();
  }, [productId]);

  const fetchProductDetails = async () => {
    const res = await axios.get(
      "https://sunrise-backend.sunrisemeditechsystems.com/api/products"
    );
    setProductDetail(res.data);
  };

  const fetchProducts = async () => {
    const res = await axios.post(
      "https://sunrise-backend.sunrisemeditechsystems.com/api/products/view"
    );
    setProductData(res.data);
  };

  const fetchPlaceOrder = async () => {
    const res = await axios.post(
      "https://sunrise-backend.sunrisemeditechsystems.com/api/orders/place-order",
      { product_id: productId }
    );
    setPlaceOrderData(res.data[0]);
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="content-order-page">
      <div className="content">
        <div className="container-fluid">
          {/* Page Title */}
          <div className="row content-order-card">
            <div className="col-lg-7 col-md-12">
              <div className="page-title-box">
                <div className="card">
                  <div className="card-header">
                    <h5 className="wg-product-place-box">Place Orders</h5>
                  </div>
                  <div className="card-body">
                    <Formik
                      initialValues={initialValues}
                      // validationSchema={validationSchema}
                      onSubmit={handleOrderSubmit}
                    >
                      {({ values, setFieldValue }) => (
                        <Form className="product-order-form">
                          <div className="modal-body">
                            <div className="col-12 col-md-12 mb-3">
                              <label className="order-label">
                                Product Name
                              </label>
                              <Field
                                as="select"
                                name="product_id"
                                className="form-control form-input-length mb-4"
                                value={productId}
                                onChange={(e) => setProductId(e.target.value)}
                              >
                                <option value=""> -- Select Product --</option>
                                {ProductDetail.map((element) => {
                                  return (
                                    <option value={element.id}>
                                      {element.name}
                                    </option>
                                  );
                                })}
                              </Field>
                            </div>

                            <div className="row g-3">
                              <div className="col-md-6 mb-3">
                                <label className="order-label">
                                  Order Type
                                </label>
                                <Field
                                  as="select"
                                  name="orderType"
                                  className="form-control form-input-length"
                                  value={orderType}
                                  onChange={(e) => setOrderType(e.target.value)}
                                >
                                  <option value="buy">Buy</option>
                                  <option value="stand_by">Stand By</option>
                                  <option value="demo">Demo</option>
                                </Field>
                              </div>

                              <div className="col-md-6">
                                <label className="order-label">Quantity</label>
                                <Field
                                  type="number"
                                  name="quantity"
                                  className="form-control"
                                  value={quantity}
                                  onChange={(e) =>
                                    setQuantity(parseInt(e.target.value))
                                  }
                                  min="1"
                                  max={
                                    orderType === "buy"
                                      ? product?.saleStock
                                      : product?.rentalStock
                                  }
                                />
                              </div>
                            </div>

                            {/* DATES */}
                            {(orderType === "stand_by" ||
                              orderType === "demo") && (
                              <div className="row g-3">
                                <div className="col-md-6 mt-2">
                                  <label className="order-label">
                                    Start Date
                                  </label>
                                  <Field
                                    type="date"
                                    name="startDate"
                                    className="form-control form-input-length"
                                    min={new Date().toISOString().split("T")[0]}
                                    value={startDate}
                                    onChange={(e) =>
                                      setStartDate(e.target.value)
                                    }
                                  />
                                  <ErrorMessage
                                    name="startDate"
                                    component="div"
                                    className="text-danger"
                                  />
                                </div>

                                <div className="col-md-6 mt-2">
                                  <label className="order-label">
                                    End Date
                                  </label>
                                  <Field
                                    type="date"
                                    name="endDate"
                                    className="form-control"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    min={
                                      values.startDate ||
                                      new Date().toISOString().split("T")[0]
                                    }
                                  />
                                  <ErrorMessage
                                    name="endDate"
                                    component="div"
                                    className="text-danger"
                                  />
                                </div>
                              </div>
                            )}

                            {/* HOSPITAL NAME */}
                            <div className="row g-3 mt-2">
                              <div className="col-12 col-md-12 mt-2">
                                {/* <div className="mt-2"> */}
                                <label className="order-label">
                                  Hospital Name *
                                </label>
                                <Field
                                  type="text"
                                  name="hospitalName"
                                  className="form-control form-input-length"
                                  value={hospitalName}
                                  onChange={(e) =>
                                    setHospitalName(e.target.value)
                                  }
                                  required
                                />
                                <ErrorMessage
                                  name="hospitalName"
                                  component="div"
                                  className="text-danger"
                                />
                                {/* </div> */}
                              </div>

                              {/* PRODUCT TYPE (STAND BY ONLY) */}
                              {orderType === "stand_by" && (
                                <div className="col-12 col-md-12">
                                  <div className="mt-3">
                                    <label className="order-label">
                                      Product Type *
                                    </label>
                                    <Field
                                      as="select"
                                      name="productType"
                                      className="form-control"
                                    >
                                      <option value="">
                                        -- Select Type --
                                      </option>
                                      <option value="repair">Repair</option>
                                      <option value="replaced_by">
                                        Replaced By
                                      </option>
                                    </Field>
                                    <ErrorMessage
                                      name="productType"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* DOCTOR NAME & PHONE */}
                            <div className="row g-3 mt-2">
                              <div className="col-md-6 mt-3">
                                <label className="order-label">
                                  Doctor Name *
                                </label>
                                <Field
                                  type="text"
                                  name="doctorName"
                                  className="form-control form-input-length"
                                  value={doctorName}
                                  onChange={(e) =>
                                    setDoctorName(e.target.value)
                                  }
                                  required
                                />
                                <ErrorMessage
                                  name="doctorName"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>

                              <div className="col-md-6 mt-3">
                                <label className="order-label">
                                  Doctor Phone *
                                </label>
                                <Field
                                  type="tel"
                                  name="doctorPhone"
                                  className="form-control"
                                  maxLength={10}
                                  value={doctorPhone}
                                  onChange={(e) =>
                                    setDoctorPhone(e.target.value)
                                  }
                                  required
                                />
                                <ErrorMessage
                                  name="doctorPhone"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            </div>

                            {/* STAND-BY FIELDS */}
                            {orderType === "stand_by" && (
                              <>
                                <div className="row g-3 mt-2">
                                  <div className="col-md-6 mt-3">
                                    <label className="order-label">
                                      Receiver Name *
                                    </label>
                                    <Field
                                      type="text"
                                      name="receiverName"
                                      className="form-control form-input-length"
                                      value={receiverName}
                                      onChange={(e) =>
                                        setReceiverName(e.target.value)
                                      }
                                      required
                                    />
                                    <ErrorMessage
                                      name="receiverName"
                                      className="text-danger"
                                      component="div"
                                    />
                                  </div>

                                  <div className="col-md-6 mt-3">
                                    <label className="order-label">
                                      Receiver Phone *
                                    </label>
                                    <Field
                                      type="tel"
                                      name="receiverPhone"
                                      className="form-control"
                                      value={receiverPhone}
                                      maxLength={10}
                                      onChange={(e) =>
                                        setReceiverPhone(e.target.value)
                                      }
                                      required
                                    />
                                    <ErrorMessage
                                      name="receiverPhone"
                                      className="text-danger"
                                      component="div"
                                    />
                                  </div>
                                </div>
                                <div className="col-12 col-md-12 mt-3">
                                  <label className="order-label">Photo</label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    onChange={handleFileChange}
                                    required
                                  />
                                  <ErrorMessage
                                    name="photo"
                                    component="div"
                                    className="text-danger"
                                  />
                                </div>

                                <div className="col-12 col-md-12 mt-3">
                                  <label className="order-label">Notes *</label>
                                  <Field
                                    as="textarea"
                                    name="notes"
                                    className="form-control"
                                    rows="3"
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                    required
                                  />
                                  <ErrorMessage
                                    name="notes"
                                    component="div"
                                    className="text-danger"
                                  />
                                </div>
                              </>
                            )}

                            {/* HOSPITAL ADDRESS */}
                            <div className="col-12 col-md-12 mt-4">
                              <label className="order-label">
                                Hospital Address *
                              </label>
                              <Field
                                as="textarea"
                                name="hospitalAddress"
                                className="form-control"
                                rows="3"
                                value={hospitalAddress}
                                onChange={(e) =>
                                  setHospitalAddress(e.target.value)
                                }
                                required
                              />
                              <ErrorMessage
                                name="hospitalAddress"
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>

                          <div className="modal-footer place-order-footer">
                            <button
                              type="submit"
                              className="btn place-order-btn"
                            >
                              Place Order
                            </button>

                            {orderType === "stand_by" && (
                              <button
                                type="button"
                                className="btn place-download-btn"
                                onClick={downloadChallan}
                              >
                                Download Challan
                              </button>
                            )}
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                  {orderType === "stand_by" && (
                    <div style={{ display: "none" }}>
                      <div id="standby-challan">
                        <div>
                          <h2 style={{ textAlign: "center" }}>
                            Stand-By Product Challan
                          </h2>
                          <hr />
                          <p>
                            <b>Hospital Name:</b> {hospitalName}
                          </p>
                          <p>
                            <b>Doctor Name:</b> {doctorName}
                          </p>
                          <p>
                            <b>Doctor Phone:</b> {doctorPhone}
                          </p>
                          <p>
                            <b>Hospital Address:</b> {hospitalAddress}
                          </p>
                          <p>
                            <b>Receiver Name:</b> {receiverName}
                          </p>
                          <p>
                            <b>Receiver Phone:</b> {receiverPhone}
                          </p>
                          <p>
                            <b>Product Type:</b> {productType}
                          </p>
                          <p>
                            <b>Product:</b> {productData?.name}
                          </p>
                          <p>
                            <b>Quantity:</b> {quantity}
                          </p>
                          <p>
                            <b>Start Date:</b> {startDate}
                          </p>
                          <p>
                            <b>End Date:</b> {endDate}
                          </p>
                          <p>
                            <b>Notes:</b> {notes}
                          </p>
                          <hr />
                          <h4>Total Amount: ₹{calculateTotal()}</h4>
                          <div
                            style={{ marginTop: "40px", textAlign: "right" }}
                          >
                            <p>Authorized Signature: _____________________</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {placeOrderData ? (
              <div className="col-lg-5 col-md-12">
                <div className="wg-box mb-20 gap10">
                  <div className="body-title" style={{ marginBottom: "-15px" }}>
                    <div className="wg-product-place-box">Product Detail</div>
                  </div>
                  <div className="row">
                    <div className="summary-item col-md-6 place-order-body">
                      <div className="body-text">
                        <div className="Wg-product-box">Name</div>
                      </div>
                      <div className="summary-title">{placeOrderData.name}</div>
                    </div>

                    <div className="summary-item col-md-6">
                      <div className="body-text">
                        <div className="Wg-product-box">Date</div>
                      </div>
                      <div className="body-title-2 summary-title">
                        {formatDate(placeOrderData.created_at)}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="summary-item col-md-6 place-order-body">
                      <div className="body-text">
                        <div className="Wg-product-box">Total</div>
                      </div>
                      <div className="body-title-2 summary-title tf-color-1">
                        ₹ {placeOrderData.salePrice ? placeOrderData.salePrice :0}
                      </div>
                    </div>

                    <div className="summary-item col-md-6">
                      <div className="body-text">
                        <div className="Wg-product-box">Sale Stock</div>
                      </div>
                      <div className="body-title-2 summary-title tf-color-1">
                        ₹ {placeOrderData.saleStock ? placeOrderData.saleStock :0}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="summary-item col-md-6 place-order-body" >
                      <div className="body-text">
                        <div className="Wg-product-box">Stand By Stock</div>
                      </div>
                      <div className="body-title-2 summary-title tf-color-1">
                        ₹ {placeOrderData.standByStock ? placeOrderData.standByStock :0}
                      </div>
                    </div>

                    <div className="summary-item col-md-6">
                      <div className="body-text">
                        <div className="Wg-product-box">Demo Stock</div>
                      </div>
                      <div className="body-title-2 summary-title tf-color-1">
                        ₹ {placeOrderData.demoStock ? placeOrderData.demoStock :0}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="wg-box mb-20 gap10">
                  <div className="body-title">
                    <div className="wg-product-place-box">Description</div>
                  </div>
                  <div
                    className="body-text summary-title"
                    style={{ fontWeight: 500, fontSize: "19px" }}
                  >
                    {placeOrderData.description ? placeOrderData.description :"-"}
                  </div>
                </div>

                <div className="wg-box mb-20 gap10">
                  <div className="body-title">
                    <div className="wg-product-place-box">Image</div>
                  </div>
                  <div className="body-text">
                    <img
                      src={`https://sunrise-backend.sunrisemeditechsystems.com/${placeOrderData.image}`}
                      alt="image"
                      className="wg-product-img"
                      style={{width:"-webkit-fill-available"}}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-lg-5 col-md-12">
                <div className="wg-box mb-20 gap10">
                  <div className="body-title">No Record Found</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default PlaceOrders;
